type ToastOptions = {
  message: string
  color?: 'success' | 'danger' | 'warning' | 'info'
  duration?: number
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'top-center' | 'bottom-center'
}

type NotifyFunction = (options: ToastOptions | string) => void

let notifyFn: NotifyFunction | null = null

export const toastService = {
  init(notify: NotifyFunction) {
    notifyFn = notify
  },

  success(message: string) {
    notifyFn?.({ message, color: 'success', duration: 3000, position: 'top-center' })
  },

  error(message: string) {
    notifyFn?.({ message, color: 'danger', duration: 5000, position: 'top-center' })
  },

  warning(message: string) {
    notifyFn?.({ message, color: 'warning', duration: 5000, position: 'top-center' })
  },

  info(message: string) {
    notifyFn?.({ message, color: 'info', duration: 3000, position: 'top-center' })
  },
}

export default toastService
